let resIndex = 0;

export const getResIndex = () => {
  return resIndex++;
}